import { supabase } from '../lib/supabase'

/**
 * Fetch a barangay by its unique slug
 * @param {string} slug - The barangay slug (e.g., "fairview")
 * @returns {Promise<Object|null>} Barangay data or null if not found
 */
export const getBarangayBySlug = async (slug) => {
  try {
    const { data, error } = await supabase
      .from('barangays')
      .select('*')
      .eq('slug', slug)
      .eq('status', 'active')
      .single()

    if (error) {
      if (error.code === 'PGRST116') {
        // No rows returned
        return null
      }
      throw error
    }

    return data
  } catch (error) {
    console.error('Error fetching barangay:', error)
    throw error
  }
}

/**
 * Fetch all active barangays for navigation dropdown
 * @returns {Promise<Array>} List of active barangays
 */
export const getAllBarangays = async () => {
  try {
    const { data, error } = await supabase
      .from('barangays')
      .select('id, name, slug')
      .eq('status', 'active')
      .order('name', { ascending: true })

    if (error) throw error

    return data || []
  } catch (error) {
    console.error('Error fetching barangays:', error)
    throw error
  }
}
